
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesReportDialog extends Serenity.EntityDialog<POSSalesReportRow, any> {
        protected getFormKey() { return POSSalesReportForm.formKey; }
        protected getIdProperty() { return POSSalesReportRow.idProperty; }
        protected getLocalTextPrefix() { return POSSalesReportRow.localTextPrefix; }
        protected getNameProperty() { return POSSalesReportRow.nameProperty; }
        protected getService() { return POSSalesReportService.baseUrl; }
        protected getDeletePermission() { return POSSalesReportRow.deletePermission; }
        protected getInsertPermission() { return POSSalesReportRow.insertPermission; }
        protected getUpdatePermission() { return POSSalesReportRow.updatePermission; }

        protected form = new POSSalesReportForm(this.idPrefix);

    }
}